var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field-creator" },
    [
      _c(
        "a-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.createField.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("message.name"), required: true } },
            [
              _c("a-input", {
                model: {
                  value: _vm.field.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.field, "name", $$v)
                  },
                  expression: "field.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.fieldType"), required: true } },
            [
              _c(
                "a-select",
                {
                  on: { change: _vm.onFieldTypeChange },
                  model: {
                    value: _vm.field.fieldType,
                    callback: function ($$v) {
                      _vm.$set(_vm.field, "fieldType", $$v)
                    },
                    expression: "field.fieldType",
                  },
                },
                _vm._l(_vm.fieldTypes, function (type) {
                  return _c(
                    "a-select-option",
                    { key: type.value, attrs: { value: type.value } },
                    [_vm._v("\n          " + _vm._s(type.label) + "\n        ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.alignment"), required: true } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.field.alignment,
                    callback: function ($$v) {
                      _vm.$set(_vm.field, "alignment", $$v)
                    },
                    expression: "field.alignment",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "left" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.left"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "center" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.center"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "right" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.right"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.field.fieldType === "datetime"
            ? [
                _c("a-divider", [_vm._v("Datetime Options")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.timezone") } },
                  [
                    _c("a-auto-complete", {
                      attrs: {
                        dataSource: _vm.timezones,
                        placeholder: _vm.$t("tables.timezone"),
                        filterOption: _vm.filterOption,
                      },
                      model: {
                        value: _vm.field.options.datetime.timezone,
                        callback: function ($$v) {
                          _vm.$set(_vm.field.options.datetime, "timezone", $$v)
                        },
                        expression: "field.options.datetime.timezone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Format" } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.field.options.datetime.format,
                          callback: function ($$v) {
                            _vm.$set(_vm.field.options.datetime, "format", $$v)
                          },
                          expression: "field.options.datetime.format",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { attrs: { value: "MM/DD/YYYY" } },
                          [_vm._v("MM/DD/YYYY (12/31/2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD/MM/YYYY" } },
                          [_vm._v("DD/MM/YYYY (31/12/2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "YYYY-MM-DD" } },
                          [_vm._v("YYYY-MM-DD (2023-12-31)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "MM-DD-YYYY" } },
                          [_vm._v("MM-DD-YYYY (12-31-2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD-MM-YYYY" } },
                          [_vm._v("DD-MM-YYYY (31-12-2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "YYYY/MM/DD" } },
                          [_vm._v("YYYY/MM/DD (2023/12/31)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "MMM DD, YYYY" } },
                          [_vm._v("MMM DD, YYYY (Dec 31, 2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD MMM, YYYY" } },
                          [_vm._v("DD MMM, YYYY (31 Dec, 2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "MMMM DD, YYYY" } },
                          [_vm._v("MMMM DD, YYYY (December 31, 2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD MMMM, YYYY" } },
                          [_vm._v("DD MMMM, YYYY (31 December, 2023)")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.includeTime") } },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.field.options.datetime.includeTime,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.field.options.datetime,
                            "includeTime",
                            $$v
                          )
                        },
                        expression: "field.options.datetime.includeTime",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.field.options.datetime.includeTime
                  ? _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("tables.timeFormat") } },
                      [
                        _c(
                          "a-select",
                          {
                            model: {
                              value: _vm.field.options.datetime.timeFormat,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.field.options.datetime,
                                  "timeFormat",
                                  $$v
                                )
                              },
                              expression: "field.options.datetime.timeFormat",
                            },
                          },
                          [
                            _c(
                              "a-select-option",
                              { attrs: { value: "HH:mm" } },
                              [_vm._v("HH:mm (23:59)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "hh:mm A" } },
                              [_vm._v("hh:mm A (11:59 PM)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "HH:mm:ss" } },
                              [_vm._v("HH:mm:ss (23:59:59)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "hh:mm:ss A" } },
                              [_vm._v("hh:mm:ss A (11:59:59 PM)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "HH:mm:ss.SSS" } },
                              [_vm._v("HH:mm:ss.SSS (23:59:59.999)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "hh:mm:ss.SSS A" } },
                              [_vm._v("hh:mm:ss.SSS A (11:59:59.999 PM)")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm.field.fieldType === "number"
            ? [
                _c("a-divider", [_vm._v("Number Options")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.decimalFormat") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.field.options.number.decimalFormat,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.field.options.number,
                              "decimalFormat",
                              $$v
                            )
                          },
                          expression: "field.options.number.decimalFormat",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "0" } }, [
                          _vm._v("0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0" } }, [
                          _vm._v("0.0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00" } }, [
                          _vm._v("0.00"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.000" } }, [
                          _vm._v("0.000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0000" } }, [
                          _vm._v("0.0000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00000" } }, [
                          _vm._v("0.00000"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "0.000000" } },
                          [_vm._v("0.000000")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.field.fieldType === "currency"
            ? [
                _c("a-divider", [_vm._v("Currency Options")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.currencySymbol") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.field.options.currency.symbol,
                          callback: function ($$v) {
                            _vm.$set(_vm.field.options.currency, "symbol", $$v)
                          },
                          expression: "field.options.currency.symbol",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "$" } }, [
                          _vm._v("$ (USD)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "€" } }, [
                          _vm._v("€ (EUR)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "£" } }, [
                          _vm._v("£ (GBP)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "¥" } }, [
                          _vm._v("¥ (JPY)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₽" } }, [
                          _vm._v("₽ (RUB)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₹" } }, [
                          _vm._v("₹ (INR)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₺" } }, [
                          _vm._v("₺ (TRY)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₩" } }, [
                          _vm._v("₩ (KRW)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "R$" } }, [
                          _vm._v("R$ (BRL)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "¥" } }, [
                          _vm._v("¥ (CNY)"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.decimalFormat") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.field.options.currency.decimalFormat,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.field.options.currency,
                              "decimalFormat",
                              $$v
                            )
                          },
                          expression: "field.options.currency.decimalFormat",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "0" } }, [
                          _vm._v("0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0" } }, [
                          _vm._v("0.0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00" } }, [
                          _vm._v("0.00"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.000" } }, [
                          _vm._v("0.000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0000" } }, [
                          _vm._v("0.0000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00000" } }, [
                          _vm._v("0.00000"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "0.000000" } },
                          [_vm._v("0.000000")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.field.fieldType === "dropdown"
            ? [
                _c("a-divider", [_vm._v("Dropdown Options")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.mode") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.field.options.dropdown.mode,
                          callback: function ($$v) {
                            _vm.$set(_vm.field.options.dropdown, "mode", $$v)
                          },
                          expression: "field.options.dropdown.mode",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "static" } }, [
                          _vm._v(_vm._s(_vm.$t("tables.statics"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "dynamic" } }, [
                          _vm._v(_vm._s(_vm.$t("tables.dynamics"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Multiple Selection" } },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.field.options.dropdown.multiple,
                        callback: function ($$v) {
                          _vm.$set(_vm.field.options.dropdown, "multiple", $$v)
                        },
                        expression: "field.options.dropdown.multiple",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.field.options.dropdown.mode === "static"
                  ? _c(
                      "div",
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "Options" } },
                          [
                            _vm._l(
                              _vm.field.options.dropdown.options,
                              function (option, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "option-item" },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "60%" },
                                      attrs: { placeholder: "Value" },
                                      model: {
                                        value: option.value,
                                        callback: function ($$v) {
                                          _vm.$set(option, "value", $$v)
                                        },
                                        expression: "option.value",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a-select",
                                      {
                                        staticStyle: {
                                          width: "30%",
                                          "margin-left": "10px",
                                        },
                                        attrs: { placeholder: "Color" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "suffixIcon",
                                              fn: function () {
                                                return [
                                                  _c("div", {
                                                    staticClass: "color-box",
                                                    style: {
                                                      backgroundColor:
                                                        _vm.selectedColor(
                                                          option.color
                                                        ),
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: option.color,
                                          callback: function ($$v) {
                                            _vm.$set(option, "color", $$v)
                                          },
                                          expression: "option.color",
                                        },
                                      },
                                      [
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.colors,
                                          function (color, colorIndex) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: colorIndex,
                                                attrs: { value: color.value },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "color-option",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "color-box",
                                                      style: {
                                                        backgroundColor:
                                                          color.value,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(color.label)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("a-button", {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "danger", icon: "delete" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeOption(index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "dashed", icon: "plus" },
                                on: { click: _vm.addOption },
                              },
                              [_vm._v(_vm._s(_vm.$t("tables.addOption")))]
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm.field.fieldType === "automation-button"
            ? [
                _c("a-divider", [_vm._v("Automation Button Options")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Automation Name" } },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.field.options.button.automationName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.field.options.button,
                            "automationName",
                            $$v
                          )
                        },
                        expression: "field.options.button.automationName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Default Label", required: true } },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.field.options.button.defaultLabel,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.field.options.button,
                            "defaultLabel",
                            $$v
                          )
                        },
                        expression: "field.options.button.defaultLabel",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Disable When Clicked" } },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.field.options.button.disableWhenClicked,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.field.options.button,
                            "disableWhenClicked",
                            $$v
                          )
                        },
                        expression: "field.options.button.disableWhenClicked",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-form-item",
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    "html-type": "submit",
                    loading: _vm.loading,
                    disabled: _vm.loading,
                  },
                },
                [_vm._v(_vm._s(_vm.$t("tables.create")))]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                { attrs: { disabled: _vm.loading }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }